import { trapiClient } from './trapiClient';
import type { Environment } from '../../contexts/AppContext';
import type { AliasObject } from '../../types/trapi';

export class AliasesService {
  private static readonly BASE_PATH = '/configs';

  static async getAliases(params: { apiPath: string; environment: Environment; accessToken: string }): Promise<AliasObject[]> {
    const { apiPath, environment, accessToken } = params;
    // Don't use URLSearchParams to avoid encoding characters that the API expects unencoded
    const url = `${this.BASE_PATH}?ci=ALIAS&apiPath=${apiPath}`;
    if (trapiClient.getEnvironment() !== environment) trapiClient.setEnvironment(environment);
    
    const response = await trapiClient.get<AliasObject[]>(url, accessToken);
    return Array.isArray(response) ? response : [];
  }

  static async createAlias(params: { 
    aliasPath: string; 
    apiPath: string; 
    environment: Environment; 
    accessToken: string 
  }): Promise<AliasObject> {
    const { aliasPath, apiPath, environment, accessToken } = params;
    
    // Generate a GUID for the new alias
    const id = crypto.randomUUID();
    
    const payload: AliasObject = {
      id,
      type: 'ADMINCI',
      ci: 'ALIAS',
      aliasPath,
      apiPath
    };

    if (trapiClient.getEnvironment() !== environment) trapiClient.setEnvironment(environment);
    
    // Use PUT to base path for creation, following the same pattern as other services
    return trapiClient.put<AliasObject>(this.BASE_PATH, payload, accessToken);
  }

  static async deleteAlias(params: { 
    id: string; 
    environment: Environment; 
    accessToken: string 
  }): Promise<void> {
    const { id, environment, accessToken } = params;
    
    if (trapiClient.getEnvironment() !== environment) trapiClient.setEnvironment(environment);
    
    const url = `${this.BASE_PATH}/${encodeURIComponent(id)}`;
    await trapiClient.delete<void>(url, accessToken);
  }
}
